import { gql } from "@apollo/client";

export const GET_HOST_INSTITUTION_BY_ID = gql`
  query HostInstitutionById($_id: ID!) {
    hostInstitutionById(_id: $_id) {
      _id
      name
      address {
        street
        street_number
        city
        city_code
        state
        country
      }
      admin_contact {
        firstname
        lastname
        phone
        email
      }
      IT_contact {
        firstname
        lastname
        phone
        email
      }
      IT_environment {
        PACS {
          manufacturer
          model
          IP_address
        }
      }
      schema_version
    }
  }
`;

export const GET_ALL_HOST_INSTITUTIONS = gql`
  query GetAllHostInstitutions {
    hostInstitutions {
      _id
      name
      address {
        street
        street_number
        city
        city_code
        state
        country
      }
      admin_contact {
        firstname
        lastname
        phone
        email
      }
      IT_contact {
        firstname
        lastname
        phone
        email
      }
      IT_environment {
        PACS {
          manufacturer
          model
          IP_address
        }
      }
      schema_version
    }
  }
`;

export const GET_HOST_INSTITUTIONS_BY_IDS = gql`
  query GetHostInstitutionsByIds($ids: [ID!]!) {
    hostInstitutionsByIds(ids: $ids) {
      _id
      name
      address {
        street
        street_number
        city
        city_code
        state
        country
      }
      admin_contact {
        firstname
        lastname
        phone
        email
      }
      IT_contact {
        firstname
        lastname
        phone
        email
      }
      IT_environment {
        PACS {
          manufacturer
          model
          IP_address
        }
      }
      schema_version
    }
  }
`;
